import { breakpoints } from './breakpoints'
import { colors } from './colors'
import { typography } from './typography'
import { space } from './space'

export const theme = { breakpoints, colors, space, typography }
